import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { IconComponentV2 } from '../../shared/components/icon-component/icon.component';

@Component({
  selector: 'app-product-selection-list',
  standalone: true,
  imports: [CommonModule, IconComponentV2],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex flex-col gap-1 px-3 py-1">
      @for (product of products; track product.value) {
        <button 
          (click)="selectProduct(product.value)"
          class="flex items-center justify-between p-2.5 rounded-xl transition-all active:scale-[0.98] group"
          [class]="selectedId === product.value 
            ? 'bg-purple-50/50 dark:bg-white/10' 
            : 'hover:bg-gray-50 dark:hover:bg-surface-3'"
        >
          <div class="flex items-center gap-3">
            <div class="w-9 h-9 rounded-lg bg-white dark:bg-surface-1 flex items-center justify-center shadow-sm overflow-hidden border border-gray-100 dark:border-surface-1">
               @if (product.icon) {
                 <img [src]="product.icon" class="w-full h-full object-cover" alt="product icon" />
               } @else {
                 <app-icon-v2 name="layoutDashboard" [size]="18" class="text-gray-400 dark:text-ink-soft"></app-icon-v2>
               }
            </div>
            <div class="flex flex-col text-left">
              <span class="text-sm font-bold uppercase tracking-wider transition-colors duration-200"
                    [class]="selectedId === product.value ? 'text-purple-600 dark:text-white' : 'text-[#141437] dark:text-ink-soft'">
                {{ product.label }}
              </span>
            </div>
          </div>
        </button>
      }
    </div>
  `
})
export class ProductSelectionListComponent {
  @Input() products: any[] = [];
  @Input() selectedId: string | null = null;
  
  private _bottomSheetRef = inject(MatBottomSheetRef);

  selectProduct(id: string) {
    this._bottomSheetRef.dismiss(id);
  }
}
